import React, { useState, useEffect } from "react";
import { useHttp } from "../../hooks/useHttp";
import { API_URLS, DEFAULT_HEADERS } from "../../util/constants";
import Loader from "../../components/Loader";
import SEO from "../../components/SEO";
import { useAuth } from "../../hooks/useAuth";

const TermsAndPrivacy = () => {
  const { isLoggedIn } = useAuth();
  const [content, setContent] = useState(null);
  const [error, setError] = useState(null);
  const { sendRequest } = useHttp();

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        console.log("fetchTerms");
        const res = await sendRequest(
          API_URLS.TERMS.DOCUMENT,
          "GET",
          null,
          DEFAULT_HEADERS.JSON
        );
        if (res?.success && res?.content) {
          setContent(res.content);
        } else {
          setError("Não foi possível carregar os termos.");
        }
      } catch (err) {
        setError(err?.message || "Erro ao carregar os termos.");
      }
    };
    fetchTerms();
  }, []);

  if (error) {
    return (
      <div className="container py-5">
        <div className="alert alert-danger">{error}</div>
      </div>
    );
  }

  if (!content) {
    return <Loader type="pulse" size="medium" fullScreen />;
  }

  return (
    <>
      <SEO
        title="Termos de Uso e Política de Privacidade | Grupo Terra"
        description="Termos de uso e política de privacidade da área de compras do Grupo Terra."
        keywords="termos de uso, política de privacidade, grupo terra"
      />
      <div className="container py-5">
        <h1 className="mb-4 text-dark">Termos de Uso e Política de Privacidade</h1>
        <div className="mb-4">
          <div
            className="terms-content text-dark"
            dangerouslySetInnerHTML={{ __html: content.terms_content }}
          />
        </div>
        <div>
          <div
            className="privacy-content text-dark"
            dangerouslySetInnerHTML={{ __html: content.privacy_content }}
          />
        </div>
      </div>
    </>
  );
};

export default TermsAndPrivacy;
